

export const goodsManageListNewData = [
  {
    id: 'baseInfo',
    title: '添加用户',
    footerShow:'special',
    data: [
      {
        id: 'workunit',
        name: '单位',
        placeholder: '',
        type: 'select',
        checkType: 'required',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: [],
        tips:'',
        options: [],
        expand: {},
        jpath: 'workunit'
      },
      {
        id: 'realname',
        name: '姓名',
        placeholder: '请输入姓名',
        type: 'input',
        checkType: 'required',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'realname'
      },
      {
        id: 'password',
        name: '密码',
        placeholder: '请输入密码',
        type: 'input',
        checkType: 'required',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'password'
      },
      {
        id: 'mobile',
        name: '手机号',
        placeholder: '请输入手机号',
        type: 'input',
        checkType: 'required',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'mobile'
      },
      {
        id: 'email',
        name: 'Email',
        placeholder: '请输入Email',
        type: 'input',
        checkType: '',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'email'
      }
    ]
  }
];
